<template>
    <v-dialog
      v-model="dialog"
      fullscreen
      persistent
    >
      <v-card class="primary" dark>
        <v-layout row wrap>
          <v-flex xs12 sm6 offset-sm3>

            <v-card-title class="headline">New Version</v-card-title>
            <v-card-text>
            An important update is available and must be installed before you can continue using the app.
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="amber accent-4"
                @click="update()"
                block
                large>
                Update Now
              </v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: ['dialog'],
  methods: {
    update () {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister()
        }
      })
      .then(function (boolean) {
        caches.delete('v1-engineer-cache').then(function (boolean) {
          window.location.reload(true)
        })
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// UpdateDialog.vue?ea710ade